import useSWR from 'swr';
import type { IUserProfileView } from '@shared/services';
import { getUserProfile } from '../requests';

/** The SWR cache key for the signed-in account's profile; also the endpoint the fetcher hits. */
export const USER_PROFILE_KEY = '/api/v1/users/profile';

/**
 * Loads the signed-in account's profile over the session-authorized `authApi`. Exposes `mutate` so the
 * General tab can revalidate the profile in place after a successful update — no full page reload.
 */
export const useUserProfile = () => {
  const { data, error, isLoading, mutate } = useSWR<IUserProfileView>(USER_PROFILE_KEY, getUserProfile);

  return { profile: data, isLoading, error, mutate };
};
